import ls from "local-storage";

export default class CookieBasedCommands {
    #commands = null;

    constructor(commands = null) {
        this.#commands = commands;
    }

    /**
     * @param {string} key
     * @param {string} value
     */
    #register(key, value) {
        ls.set(key, value);
    }

    /**
     * @param {string} key
     */
    #unRegister(key) {
        ls.remove(key);
    }

    /**
     * Registers a command to call later and calls the method with the stored value.
     * @param {string} key
     * @param {string} value
     */
    registerCommand(key, value) {
        this.#register(key, value);
    }

    /**
     * Returns the existing stored value of a command.
     * @param key
     * @return {*}
     */
    getCommand(key) {
        return ls.get(key);
    }

    /**
     * Un-Registers an existing command by its key.
     * @param {string} key
     */
    unRegisterCommand(key) {
        this.#unRegister(key);
    }

    /**
     * Takes an array of param keys and looks for them in the url search params.
     * If they exist, they get registered as a command later.
     * @param {array<string>} param_keys
     */
    lookForParamsAndRegister(param_keys) {
        const url = new URL(window.location.href);
        const search_params = new URLSearchParams(url.search);

        param_keys.forEach((param) => {
            if (search_params.has(param)) {
                this.registerCommand(param, search_params.get(param));
            }
        });
    }

    /**
     * Executes commands whose keys have been registered.
     */
    executeCommands() {
        for (const key in this.#commands) {
            const stored_value = ls.get(key);

            stored_value && this.#commands[key](stored_value);
        }
    }
}
